import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (credentials) => api.post('/admin/login', credentials);
export const getMe = () => api.get('/admin/me');

// Releases
export const getReleases = () => api.get('/releases');
export const getReleaseById = (id) => api.get(`/releases/${id}`);
export const createRelease = (data) => api.post('/releases', data);
export const updateRelease = (id, data) => api.put(`/releases/${id}`, data);
export const deleteRelease = (id) => api.delete(`/releases/${id}`);

// External Releases
export const getExternalReleases = () => api.get('/external-releases');
export const getExternalReleaseById = (id) => api.get(`/external-releases/${id}`);
export const createExternalRelease = (data) => api.post('/external-releases', data);
export const updateExternalRelease = (id, data) => api.put(`/external-releases/${id}`, data);
export const deleteExternalRelease = (id) => api.delete(`/external-releases/${id}`);

// Artists
export const getArtists = () => api.get('/artists');
export const getArtistById = (id) => api.get(`/artists/${id}`);
export const getArtistReleases = (id) => api.get(`/artists/${id}/releases`);
export const createArtist = (data) => api.post('/artists', data);
export const updateArtist = (id, data) => api.put(`/artists/${id}`, data);
export const deleteArtist = (id) => api.delete(`/artists/${id}`);

// Events
export const getEvents = () => api.get('/events');
export const createEvent = (data) => api.post('/events', data);
export const updateEvent = (id, data) => api.put(`/events/${id}`, data);
export const deleteEvent = (id) => api.delete(`/events/${id}`);

// Contacts
export const getContacts = () => api.get('/contacts');
export const updateContactStatus = (id, status) => api.put(`/contacts/${id}`, { status });
export const deleteContact = (id) => api.delete(`/contacts/${id}`);

// Analytics
export const getAnalytics = () => api.get('/analytics');

// Contact Form
export const submitContact = (data) => api.post('/contact', data);

// Hero Slides
export const getHeroSlides = () => api.get('/hero-slides');
export const getAllHeroSlides = () => api.get('/hero-slides/all');
export const createHeroSlide = (data) => api.post('/hero-slides', data);
export const updateHeroSlide = (id, data) => api.put(`/hero-slides/${id}`, data);
export const deleteHeroSlide = (id) => api.delete(`/hero-slides/${id}`);

// Partners
export const getPartners = () => api.get('/partners');
export const getAllPartners = () => api.get('/partners/all');
export const createPartner = (data) => api.post('/partners', data);
export const updatePartner = (id, data) => api.put(`/partners/${id}`, data);
export const deletePartner = (id) => api.delete(`/partners/${id}`);

// About Section
export const getAboutSection = () => api.get('/about-section');
export const updateAboutSection = (data) => api.put('/about-section', data);

// About Features
export const getAboutFeatures = () => api.get('/about-features');
export const createAboutFeature = (data) => api.post('/about-features', data);
export const updateAboutFeature = (id, data) => api.put(`/about-features/${id}`, data);
export const deleteAboutFeature = (id) => api.delete(`/about-features/${id}`);



// Contact Info
export const getContactInfo = () => api.get('/contact-info');
export const updateContactInfo = (data) => api.put('/contact-info', data);

// Social Media
export const getSocialMedia = () => api.get('/social-media');
export const createSocialMedia = (data) => api.post('/social-media', data);
export const updateSocialMedia = (id, data) => api.put(`/social-media/${id}`, data);
export const deleteSocialMedia = (id) => api.delete(`/social-media/${id}`);

// Terms & Conditions
export const getTermsConditions = () => api.get('/terms-conditions');
export const createTermsConditions = (data) => api.post('/terms-conditions', data);
export const updateTermsConditions = (id, data) => api.put(`/terms-conditions/${id}`, data);
export const deleteTermsConditions = (id) => api.delete(`/terms-conditions/${id}`);

// User Management
export const getUsers = () => api.get('/users');
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const resetUserPassword = (id, newPassword) => api.post(`/users/${id}/reset-password`, { new_password: newPassword });

// Password Management
export const changePassword = (data) => api.post('/admin/change-password', data);

// Gallery
export const getGalleriesByCategory = (category) => api.get(`/galleries/${category}`);
export const createGallery = (data) => api.post('/galleries', data);
export const updateGallery = (id, data) => api.put(`/galleries/${id}`, data);
export const deleteGallery = (id) => api.delete(`/galleries/${id}`);

// Party Albums
export const getPartyAlbums = () => api.get('/party-albums');
export const getPartyAlbum = (id) => api.get(`/party-albums/${id}`);
export const createPartyAlbum = (data) => api.post('/party-albums', data);
export const updatePartyAlbum = (id, data) => api.put(`/party-albums/${id}`, data);
export const deletePartyAlbum = (id) => api.delete(`/party-albums/${id}`);
export const addPhotoToAlbum = (albumId, data) => api.post(`/party-albums/${albumId}/photos`, data);
export const removePhotoFromAlbum = (albumId, photoId) => api.delete(`/party-albums/${albumId}/photos/${photoId}`);

// File Upload
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default api;